define((require) => {
    "use strict";

    var $                        = require("jquery"),
        _                        = require("underscore"),
        Backbone                 = require("backbone"),
        EditorEvents             = require("shared/services/EditorEvents"),
        ImprovedModel            = require("shared/zbone/ImprovedModel"),
        LoggedIn                 = require("shared/security/LoggedIn"),
        LoggedInUserState        = require("shared/ui/user/LoggedInUserState"),
        RestApi                  = require("shared/services/RestApi"),
        Share                    = require("ui/share/Share"),
        ShareRecipientCollection = require("ui/share/ShareRecipientCollection"),
        SyncManager              = require("shared/services/sync/SyncManager"),
        User                     = require("editor/ui/user/User"),
        UserCollection           = require("ui/user/UserCollection");

    /**
     * The view model for the share button and menu.
     *
     * @author Bruce Mackenzie Nielsen
     * @class ShareViewModel
     * @constructor
     */
    return ImprovedModel.extend({
        defaults: {
            /**
             * Simple state machine with following states:
             * 0 = No share in progress. Button shows tooltip on hover and goes to state 1 on click.
             * 1 = Share in progress. Share menu is open. Goes to state 2 on share, goes to state 0 on cancel.
             * 2 = Share completed. Button shows "thanks for sharing" tooltip and goes to state 1 on click, state 0 after timeout.
             */
            state: 0,
            recipients: null,
            message: "",
            route: ""
        },

        initialize: function() {
            this._reset();
            this.listenTo(this, "change:state", this._stateChangeHandler);
        },

        _reset: function() {
            // Resets the view model so that it is ready for a new share from the same location
            this.set({
                recipients: new ShareRecipientCollection(),
                message: ""
            });
        },

        /**
         * Returns the appropriate share link.
         * <p>Right now the user can share an experience from the viewer, editor or the quickview.
         * The quickview is the only view that sets the route since it's not known when opening it. </p>
         * <p>If no route property was defined, then the URL fragment is used.<p>
         *
         * @returns {String} the route to use.
         */
        _getRoute: function() {
            var route = this.get("route");

            if (!route) {
                return Backbone.history.fragment;
            }

            return route;
        },

        _stateChangeHandler: function() {
            // Share is being sent
            if (this.get("state") === 2) {
                // Create the share
                var share = new Share({
                    to: [],
                    message: this.get("message"),
                    link: this._getRoute()
                });

                // Add all of the selected registered users as recipients
                this.get("recipients").each((recipient) => {
                    if (recipient.get("selected") && recipient.get("user")) {
                        share.addRecipient(recipient.get("user"));
                    }
                });

                // Create new users
                var experience = this.get("experience"),
                    newUserRecipients = this.get("recipients").filter((recipient) => {
                        return !recipient.get("user") && recipient.get("email");
                    });
                if (newUserRecipients.length > 0) {
                    var newUserEmails = _.map(newUserRecipients, (recipient) => {
                        return recipient.get("email");
                    });

                    // Only track new recipients
                    SyncManager.onSync({
                        target: share,
                        once: true,
                        callback: function() {
                            var eventProperties = {
                                createdBy:    LoggedIn.principal().get("userId"),
                                toUserEmails: newUserEmails,
                                experienceId: experience.get("id"),
                                experienceVersion: experience.get("version"),
                                experiencePushedVersion: experience.get("pushedVersion"),
                                triggerOrigin: "SendShareExperienceButton"
                            };

                            EditorEvents.trigger(EditorEvents.constants.INVITE_USER, eventProperties);
                        }
                    });

                    $.ajax({ // TODO: use SyncManager for this!
                        type: "POST",
                        url: RestApi.pathToCollection(RestApi.Collections.USERS),
                        data: JSON.stringify(newUserEmails),
                        dataType: "json",
                        contentType: "application/json"
                    })
                        .fail(() => {
                            // We don't have any failure handling right now, so just send the share with whatever users we do have
                            share.save();
                        })
                        .then((data) => {
                            LoggedInUserState.invalidateGlobalCollection(UserCollection);
                            _.each(data, (rawUser) => {
                                share.addRecipient(new User(rawUser));
                            });
                            share.save();
                        });
                } else {
                    share.save();
                }

                this._reset();
            }
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/share/ShareViewModel.js